import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreCadastroService {

  api = environment.apiSite;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) { }

  getPreCadastros() {
    return this.http.get(`precadastro`).toPromise()
  }

  getPreCadastroPorIntervalo(form) {
    return this.http.get(`precadastro/Intervalo?DataInicio=${form.dataInicio}&DataFim=${form.dataFim}`, { headers: this.headers }).toPromise()
  }

  getPreCadastrosById(precadastroId) {
    return this.http.get(`precadastro/${precadastroId}`, { headers: this.headers }).toPromise();
  }

  tranferirCondominio(form) {
    return this.http.post(`precadastro/transferir`, form, { headers: this.headers }).toPromise()
  }
}
